import instance from '@apis/instance';
import { TossOrderPaymentRequest } from '@models/order/orderPayment';

class OrderPaymentApi {
    static paymentToss(request: TossOrderPaymentRequest): Promise<never> {
        return instance.post('/order/payment/toss', request);
    }
}

export default OrderPaymentApi;
